import { type FC, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import ModalWindow from '@editor2/components/ModalWindow';

interface Attributes {
	definition?: string;
	capitalizeFirstWord?: boolean;
	termInGlossary?: string;
	alphaTermInGlossary?: string;
}

interface Props {
	isShown: boolean;
	selectedText: string;
	attributes: Attributes;
	onHide: () => void;
	onSubmit: (payload: any) => void;
	onDelete: () => void;
}

const RolloverModal: FC<Props> = (props) => {
	const { isShown, selectedText, attributes, onHide, onSubmit, onDelete } = props;

	const [term, setTerm] = useState(selectedText);
	const [definition, setDefinition] = useState((attributes && attributes.definition) || '');
	const [shouldAppearInGlossary, setShouldAppearInGlossary] = useState(true);
	const [capitalizeFirstWord, setCapitalizeFirstWord] = useState(
		!!(attributes && attributes.capitalizeFirstWord)
	);
	const [termInGlossary, setTermInGlossary] = useState(
		(attributes && attributes.termInGlossary) || ''
	);
	const [alphaTermInGlossary, setAlphaTermInGlossary] = useState(
		(attributes && attributes.alphaTermInGlossary) || ''
	);

	const onSubmitClick = () => {
		const payload = {
			term,
			definition,
			capitalizeFirstWord,
			termInGlossary,
			alphaTermInGlossary
		};

		onSubmit(payload);
		onHide();
	};

	const onDeleteClick = () => {
		if (window.confirm(`Are you sure to delete rollover for"${term}" term?`)) {
			onDelete();
			onHide();
		}
	};

	const title = <div>Add definition</div>;

	const footer = (
		<>
			{attributes && (
				<Button variant="danger" onClick={onDeleteClick}>
					Delete
				</Button>
			)}

			<Button variant="success" onClick={onSubmitClick}>
				Submit
			</Button>
		</>
	);

	return (
		<ModalWindow isShown={isShown} onHide={onHide} title={title} footer={footer}>
			<Form>
				<Form.Group>
					<Form.Label>Term</Form.Label>
					<Form.Control
						as="textarea"
						rows={1}
						defaultValue={term}
						onChange={(e) => setTerm(e.target.value)}
					/>
				</Form.Group>

				<Form.Group>
					<Form.Label>Definition</Form.Label>
					<Form.Control
						as="textarea"
						rows={2}
						defaultValue={definition}
						onChange={(e) => setDefinition(e.target.value)}
					/>
				</Form.Group>

				<Form.Group>
					<Form.Check
						type="checkbox"
						checked={shouldAppearInGlossary}
						onChange={() => setShouldAppearInGlossary(!shouldAppearInGlossary)}
						label="Should appear in glossary?"
					/>
				</Form.Group>

				<Form.Group>
					<Form.Check
						type="checkbox"
						checked={capitalizeFirstWord}
						onChange={() => setCapitalizeFirstWord(!capitalizeFirstWord)}
						label="Capitalize first word in glossary?"
					/>
				</Form.Group>

				<Form.Group>
					<Form.Label>Term in glossary</Form.Label>
					<Form.Control
						as="textarea"
						rows={1}
						defaultValue={termInGlossary}
						onChange={(e) => setTermInGlossary(e.target.value)}
					/>
				</Form.Group>

				<Form.Group>
					<Form.Label>"Alpha" term in glossary</Form.Label>
					<Form.Control
						as="textarea"
						rows={1}
						defaultValue={alphaTermInGlossary}
						onChange={(e) => setAlphaTermInGlossary(e.target.value)}
					/>
				</Form.Group>
			</Form>
		</ModalWindow>
	);
};

export default RolloverModal;
